<!-- index.vue -->
<template>
	<div class="icon-body">
		<div class="icon-list">
			<div v-for="(item,index) in iconList" :key="index" @click="selectedIcon(item)">
				<i :class="item"></i>
			</div>
		</div>
	</div>
</template>

<script>
import icons from './requireicons'

export default {
    name: 'IconSelect',
    data() {
        return {
            iconList: icons
        }
    },
    methods: {
        selectedIcon(name) {
            this.$emit('selected', name)
            document.body.click()
        }
    }
}
</script>

<style lang="scss" scoped>

.icon-body{
    width: 364px;
    height:300px;
    padding: 2px;
    .icon-list {
        overflow-y: scroll;
        height:300px;
        div {
            display: inline-block;
            width: 60px;
            height: 60px;
            font-size:30px;
            line-height: 60px;
            cursor: pointer;
            text-align:center;
        }
        div:hover {
            background:#eee;
        }
    }
}
</style>